import React from 'react';
import { useOutlet } from 'react-router-dom';
export const RenderSubRoutes = _ref => {
  let {
    children
  } = _ref;

  if (children) {
    return React.createElement(React.Fragment, null, children);
  } else {
    return useOutlet();
  }
};